<template>
    <div class="w-full">
        <Popper class="w-full" offset-distance="1">
            <input class="w-full border-gray-200 rounded-md py-1" type="text" placeholder="Search" v-model="searchString" @change="onInputChange">
            <template #content="{ close }">
                <div class="max-h-96 overflow-y-scroll w-52 py-1 bg-white shadow-lg border" role="none">
                    <a v-for="font in visibleItems" href="javascript:void(0)" @click="onFontSelected(font); close()"
                       class="text-gray-700 hover:bg-gray-100 block pl-4 pr-12 py-2 text-sm rounded" role="menuitem">{{font.family}}</a>
                </div>
            </template>
        </Popper>
    </div>
</template>

<script>
export default {
    name: 'FontsDropdown',
    props: {
        fonts: {
            type: Array
        },
        currentFont: {
            type: Object
        },
        fontPropertyName: {
            type: String,
            default: 'family'
        },
    },
    data () {
        return {
            model: webase.model,
            searchString: ''
        }
    },
    watch: {
        'currentFont.family'(newValue, oldValue) {
            this.searchString = newValue
        },
        'currentFont.font'(newValue, oldValue) {
            this.searchString = newValue
        }
    },
    computed: {
        visibleItems() {
            if(this.searchString.trim().length === 0) {
                return this.fonts
            }

            return this.fonts.filter( (font) => {
                return font.family.toLowerCase().indexOf( this.searchString.trim().toLowerCase() ) > -1
            })
        }
    },
    mounted () {
        if(this.currentFont[this.fontPropertyName] === undefined) {
            this.currentFont[this.fontPropertyName] = ''
        }

        this.searchString = this.currentFont[this.fontPropertyName]
    },
    methods: {
        onInputChange() {
            if(this.searchString === '') {
                this.currentFont[this.fontPropertyName] = ''
            }
        },
        onFontSelected(font) {
            this.currentFont[this.fontPropertyName] = font.family
            this.searchString = this.currentFont[this.fontPropertyName]
            this.$emit('fontChanged');
        }
    }
}
</script>
